module.exports = __webpack_public_path__ + "img/marked.5fc69bf4.jpg";